import { Button, Result } from "antd";
import React from "react";

export default class NotAllow extends React.Component {
    render() {
        return (
            <Result
                status="403"
                title="403"
                subTitle="Sorry, you are not authorized to access this page."
                extra={
                    <Button onClick={() => window.location.href = '/'} type="primary">Back Home</Button>
                }
            />
        )
    }
}